import { createSlice } from '@reduxjs/toolkit';
import { defaultApiState } from '../../../common/constants/api-constants';
import { ActionStatus } from '../../../common/constants/action-status';
import { AccessCodeState } from '../interfaces/access-code.interface';
import { getAccessCodeDetails, redeemAccessCode } from '../thunks/access-code.thunk';
import { classifyAccessCodeProduct } from '../access-code-product';

export const accessCodeInitialState: AccessCodeState = {
  ...defaultApiState,
  product: '',
  categories: [],
  redeemEligible: false,
  offers: [],
  redeemStatus: 'idle',
  redeemErrorCode: undefined
};

/*----- CREATE STORE ------*/
export const accessCodeSlice = createSlice({
  name: 'accessCode',
  initialState: accessCodeInitialState,
  reducers: {
    clearAccessCodeState: state => {
      state.status = ActionStatus.idle;
      state.data = undefined;
      state.error = '';
      state.product = '';
      state.categories = [];
      state.redeemEligible = false;
      state.offers = [];
      state.redeemStatus = 'idle';
      state.redeemErrorCode = undefined;
    },
  },
  extraReducers(builder) {
    builder
      .addCase(getAccessCodeDetails.pending, state => {
        state.status = ActionStatus.loading;
        state.data = undefined;
        state.error = '';
        state.product = '';
        state.categories = [];
        state.redeemEligible = false;
        state.offers = [];
        state.redeemStatus = 'idle';
        state.redeemErrorCode = undefined;
      })
      .addCase(getAccessCodeDetails.fulfilled, (state, action) => {
        state.status = ActionStatus.succeeded;
        state.data = action.payload;
        const classification = classifyAccessCodeProduct(action.payload);
        state.product = classification.product;
        state.categories = classification.categories;
        state.redeemEligible = classification.redeemEligible;
        state.offers = action.payload.offers || [];
      })
      .addCase(getAccessCodeDetails.rejected, (state, action) => {
        state.status = ActionStatus.failed;
        state.data = undefined;
        state.product = '';
        state.categories = [];
        state.redeemEligible = false;
        state.offers = [];
        const payload = action.payload as { message?: string; error?: Error } | undefined;
        state.error = payload?.message || payload?.error?.message || action.error.message || '';
      })
      .addCase(redeemAccessCode.pending, state => {
        state.redeemStatus = 'pending';
        state.redeemErrorCode = undefined;
      })
      .addCase(redeemAccessCode.fulfilled, state => {
        state.redeemStatus = 'success';
      })
      .addCase(redeemAccessCode.rejected, (state, action) => {
        state.redeemStatus = 'error';
        const payload = action.payload as { code?: string; message?: string } | undefined;
        state.redeemErrorCode = payload?.code;
        state.error = payload?.message || action.error.message || '';
      });
  }
});

export const { clearAccessCodeState } = accessCodeSlice.actions;
export const accessCodeReducer = accessCodeSlice.reducer;

